import gql from 'graphql-tag'

export const AggregateRatingsFieldsFragment = gql`
  fragment AggregateRatingsFields on AggregateRatings {
    count
    overall
    atmosphere
    physicalSpace
    learningEnvironment
    outdoorTime
    childCommunication
    programCommunication
    providerInteraction
  }
`
